<template>
    <b-row>
        <h1>{{ $t('notifications.errors.page_not_found') }}</h1>
    </b-row>
</template>

<script>
    export default {
        name: 'not-found'
    }
</script>

<style scoped>

</style>
